import { all, fork } from 'redux-saga/effects'
import { globalEvent } from './globalEvent'
import { evacResponses } from './evacResponses'

export default function* subscriptions() {
  yield all([fork(globalEvent), fork(evacResponses)])
}
